import { template as template_66c4724a5ff84d739653881e611bedd4 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { task as trackedTask } from 'reactiveweb/ember-concurrency';
import { ObjectId } from 'bson';
import { waitFor } from '@ember/test-waiters';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { filterByField, callWithMapped } from 'eflex/helpers';
import { isPresent } from '@eflexsystems/ember-composable-helpers';
import { action } from '@ember/object';
export default class BiPanelBoltData extends Component {
    @service
    intl;
    @service
    queryRunner;
    @service
    store;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.fasteners?.length > 0;
        this.args.initParam('stationIds', this.args.stationIds);
        this.args.initParam('modelIds', this.args.modelIds);
        this.args.initParam('fasteners', this.args.fasteners);
    }
    @action
    onChange(fasteners) {
        this.args.updateParam('fasteners', fasteners);
    }
    get params() {
        return {
            stationIds: this.args.getParam('stationIds'),
            modelIds: this.args.getParam('modelIds'),
            fasteners: this.args.getParam('fasteners')
        };
    }
    get selectedFasteners() {
        return this.args.getParam('fasteners');
    }
    get selectedModelsBadgeText() {
        const length = this.args.fasteners.length;
        if (typeof length !== 'number') {
            return '';
        }
        if (length === 1) {
            const fastener = this.args.fasteners[0];
            const taskId = fastener.slice(0, -1);
            const boltNumber = fastener.slice(-1);
            const fastenerTask = this.store.peekRecord('task', taskId);
            return `${this.intl.t('fastener')}: ${fastenerTask.name} ${boltNumber}`;
        }
        return this.intl.t('criteria.selectedFasteners', {
            length
        });
    }
    getFastenerData = task({
        drop: true
    }, waitFor(async (params)=>{
        const boltDataQuery = [
            {
                $match: {
                    taskType: 'torque'
                }
            },
            this.getStationMatch(params.stationIds),
            {
                $lookup: {
                    from: 'LocationBases',
                    localField: '_id',
                    foreignField: 'parent',
                    as: 'taskConfigs'
                }
            },
            {
                $unwind: {
                    path: '$taskConfigs'
                }
            },
            {
                $group: {
                    _id: '$_id',
                    taskName: {
                        $first: {
                            $first: '$captions.text'
                        }
                    },
                    maxBoltNumber: {
                        $max: '$taskConfigs.boltCount'
                    }
                }
            },
            {
                $sort: {
                    taskName: 1
                }
            }
        ];
        let fastenerData = await this.queryRunner.runQuery.perform('LocationBases', boltDataQuery);
        fastenerData = fastenerData.flatMap(({ taskName, maxBoltNumber, _id })=>{
            const fastenersArray = [];
            for(let i = 1; i <= maxBoltNumber; i++){
                fastenersArray.push({
                    _id,
                    name: `${taskName} ${this.intl.t('fastener')} ${i}`,
                    idAndFastener: `${_id}${i}`
                });
            }
            fastenersArray.toSorted((a, b)=>a.name - b.name);
            return fastenersArray;
        });
        return fastenerData;
    }));
    fastenerOptions = trackedTask(this, this.getFastenerData, ()=>[
            this.params
        ]);
    getStationMatch(stationIds) {
        if (stationIds?.length > 0) {
            return {
                $match: {
                    parent: {
                        $in: stationIds.map((stationId)=>new ObjectId(stationId))
                    }
                }
            };
        } else {
            return {
                $match: {}
            };
        }
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_66c4724a5ff84d739653881e611bedd4(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-fasteners-criteria"
        @class="align-items-end"
        @form={{@form}}
        @label="fasteners"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.selectedFasteners}}
        ...attributes
      >
        <div class="input-group">
          <div class="col">
            <div class="row">
              <div class="col">
                <@form.element
                  class="fasteners-select"
                  @controlType="power-select-multiple"
                  @value={{filterByField 'idAndFastener' this.fastenerOptions.value this.selectedFasteners}}
                  @optionLabelPath="name"
                  @options={{this.fastenerOptions.value}}
                  @onChange={{callWithMapped this.onChange 'idAndFastener'}}
                as |el|>
                  <el.control
                    class="sm"
                    @searchEnabled={{true}}
                    @placeholder={{t "bi.chartLabel.allBolts"}}
                  />
                </@form.element>
              </div>
            </div>
          </div>
        </div>
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        @isDisplayed={{@fasteners}}
        @text={{this.selectedModelsBadgeText}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
